import React from 'react';
import Img from './img-wrapper';
import idify from '../utils/idify';

const TemplateDipendenze = ({ dipendenze }) => {
  return (
    <div className="section section--dark">
      {!!dipendenze && !!dipendenze.length && (
        <div className="container-xl">
          {dipendenze.map((item, i) => (
            <React.Fragment key={item.name}>
              <span id={idify(item.name)} className="section__anchor"></span>
              <div className="row my-3">
                <div className={`col-md-5 pb-5 pb-md-2${i % 2 !== 0 ? ' order-md-2' : ''}`}>
                  <div className="problem" title={item.name}>
                    <Img image={item.image} className="problem__img" alt={item.name} />
                  </div>
                </div>
                <div className="col-md-7 d-flex flex-column justify-content-center">
                  <h2 className="problem__title px-2">{item.name}</h2>
                  <div
                    className="problem__description px-2"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  ></div>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default TemplateDipendenze;
